import { css } from 'styled-system/css';

export const mePanelStyle = {
	root: css({
		base: {
			mt: '12px',
		},
	}),
	betSettings: css({
		base: {
			position: 'relative',
			overflow: 'hidden',
			width: '100%',
			height: '285px',
		},
	}),
	panel: css({
		base: {
			position: 'absolute',
			left: 0,
			top: 0,
			right: 0,
			bottom: 0,
			width: '100%',
			height: '285px',
			display: 'flex',
			flexDirection: 'column',
			boxShadow: '0 0 0 1px {colors.brand.500_12} inset',
			rounded: '6px',
			bgColor: 'white.3',
			transition: 'transform 200ms ease-in',
			_active: {
				transform: 'translateX(0)',
			},
		},
	}),
	mainPanel: css({
		base: {
			transform: 'translateX(-100%)',
		},
	}),
	subPanel: css({
		base: {
			transform: 'translateX(100%)',
		},
	}),
	panelHeader: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			p: '6px 12px',
			height: '36px',
			bgColor: 'brand.500_12',
			fontWeight: '500',
			color: { base: 'primary.600', _dark: 'whiteOpacity.100' },
			rounded: '6px 6px 0 0',
			'& .icon': {
				width: '20px',
				height: '20px',
			}
		},
	}),
	subPanelHeader: css({
		base: {
			justifyContent: 'flex-start',
			cursor: 'pointer',
		},
	}),
	panelBody: css({
		base: {
			flex: '1',
			rounded: '0 0 6px 6px',
			overflowY: 'auto',
		},
	}),
	stakeInputMobile: css({
		base: {
			fontSize: '15px',
		},
	}),
	stakeInput: css({
		base: {
			width: '100%',
		},
	}),
	mainList: css({
		base: {
			display: 'grid',
			gridTemplateColumns: 'repeat(4, 1fr)',
			gap: '6px',
			p: '9px',
		},
	}),
	mainItem: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-start',
			flexDirection: 'column',
			mt: '12px',
			cursor: 'pointer',
		},
	}),
	mainItemIcon: css({
		base: {
			position: 'relative',
			width: '48px',
			height: '48px',
			padding: '12px',
			rounded: '6px',
			bgColor: 'brand.500',
			color: 'whiteOpacity.100',
		},
	}),
	mainItemStatus: css({
		base: {
			position: 'absolute',
			bottom: 0,
			right: 0,
			rounded: '6px 0',
			fontSize: '10px',
			lineHeight: '12px',
			px: '3px',
		}
	}),
	mainItemNew: css({
		_mars: {
			position: 'absolute',
			top: 0,
			left: 0,
			rounded: '6px 0',
			fontSize: '10px',
			lineHeight: '12px',
			px: '3px',
			bgColor: 'minus.text',
			color: 'whiteOpacity.100',
		}
	}),
	mainItemOn: css({
		base: {
			bgColor: 'secondary.400',
			color: 'blackOpacity.87',
		},
	}),
	mainItemOff: css({
		base: {
			bgColor: 'primary.700',
			color: 'whiteOpacity.100',
		},
	}),
	mainItemLabel: css({
		base: {
			mt: '10px',
			maxH: '30px',
			lineHeight: '15px',
			color: 'black.1',
			textAlign: 'center',
			lineClamp: 2,
			fontWeight: '400',
		},
	}),
	settingContainer: css({
		base: {
			px: '9px',
			pb: '9px',
		},
	}),
	settingOption: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			height: '48px',
			px: '9px',
			py: '12px',
			borderBottom: '1px solid {colors.black.5}',
			_last: {
				borderBottom: 'none',
			},
			// 要避免 :active 效果，不使用 _active
			'&[data-active="true"]': {
				color: 'brand.500_light',
			},
		},
	}),
	canHover: css({
		base: {
			cursor: 'pointer',
		}
	}),
	settingLabel: css({
		base: {},
	}),
	settingControl: css({
		base: {
			'& .icon--arrow-right': {
				width: '20px',
				height: '20px',
				color: 'black.3',
			},
			'& .icon--ticket-success-line': {
				display: 'none',
			},
			_groupActive: {
				'& .icon--ticket-success-line': {
					display: 'block',
				},
			},
		},
	}),
	quickStakeInput: css({
		base: {
			pt: '12px',
			px: 0,
			maxH: '0',
			opacity: '0.5',
			_active: {
				opacity: 1,
			},
			'& .stake-input': {
				border: '1px solid {colors.black.5}',
				_before: {
					content: '"+"',
					fontSize: '16px',
				},
			},
		},
	}),
	doneButton: css({
		_mars: {
			bgColor: 'var(--s700)',
			color: 'black.1',
			height: '46px',
			_hover: {
				bgColor: 'var(--s500)',
				color: 'brand.500_light',
			}
		},
	}),
	settingDropdownMulti: css({
		base: {
			'& .settings__group:last-child': {
				border: 'none',
			},

			'& .settings__row': {
				px: '12px',
				minH: '42px',
			},
			'& .settings__item-value': {
				fontSize: '14px',
			},
		},
		_mars: {
			border: 'none',
			
			'& .icon--dropdown': {
				w: '20px',
				h: '20px',
			}
		}
	}),
	divider: css({
		h: '1px',
		bgColor: 'black.5',
	}),
	logoutButton: css({
		_mars: {
			justifyContent: 'center',
		}
	}),
	otherSettings: css({
		_mars: {
			'--settings-boder': 'colors.black.5',
			mt: '12px',
			'& .settings__row, .account__item': {
				p: 0,
			},
			'& .settings__item-label': {
				color: 'black.3',
				fontWeight: '400',
			},
			'& .account__item': {
				minH: '42px',
			},
		},
	}),
	otherSettingRow: css({
		base: {
			borderBottom: '1px solid',
			borderBottomColor: 'black.5',
			mb: '6px',

			'& .account__item-text': {
				fontSize: '14px',
			}
		}
	}),
	settingsList: css({
		_mars: {
			mb: '-1px', // 為了隱藏最後一排剩一個 item 時的底線
			bgColor: 'me.settingsListBg',
			rounded: '6px',
			overflow: 'hidden',
			marginBottom: '6px',
			_first: {
				borderTop: 'none',
			},
			'& .settings__row': {
				px: '12px',
				minH: '44px',
			}
		}
	}),
	settingsItem: css({
		_mars: {
			borderBottom: '1px solid {colors.black.5}',
			py: '12px',
			md: {
				_hover: {
					bgColor: 'var(--s800)',
				},
			},
			'&[data-selected="true"]': {
				color: 'whiteOpacity.100',
				bgColor: 'brand.500',
				md: {
					_hover: {
						bgColor: 'brand.500',
						color: 'whiteOpacity.100',
					}
				}
			},
		},
	}),
	version: css({
		_mars: {
			px: 0,
			borderTopWidth: '1px',
			borderBottomWidth: '1px',
			borderColor: 'black.5',
			borderStyle: 'solid',
		},
	}),
	versionSwitch: css({
		_mars: {
			mt: '12px',
			boxShadow: '0 0 0 1px {colors.black.5} inset',
			rounded: '6px',
			color: 'brand.500_light',
			bgColor: 'white.3',
		},
	}),
	versionSwitchButton: css({
		_mars: {
			position: 'relative',
			_after: {
				content: '""',
				position: 'absolute',
				top: '50%',
				margin: '-6px',
				height: '12px',
				bgColor: 'black.5',
				width: '1px',
				right: 0,
			},
			_last: {
				_after: {
					display: 'none',
				}
			},
			'&[data-selected="true"]': {
				rounded: '6px',
				color: 'whiteOpacity.100',
				bgColor: 'brand.500',
				fontWeight: '700',
				_after: {
					display: 'none',
				}
			},
		},
	}),
	switchLayout: css({
		_mars: {
			mt: '9px',
		}
	}),
	switchLayoutButton: css({
		_mars: {
			w: '100%',
			minH: '30px',
			bgColor: 'primary.300_12',
			color: 'brand.500_light',
			borderColor: 'brand.500_light',
			fontSize: '12px',
			'& .icon': {
				w: '18px',
				h: '18px',
			},
			_hover: {
				bgColor: 'brand.500',
				color: 'whiteOpacity.100',
				borderColor: 'brand.500',
			}
		}
	}),
	messageText: css({
		_mars: {
			color: 'black.2',
		}
	}),
	// transaction
	transaction: css({
		base: {
			position: 'relative',
			width: '100%',
			mb: '12px',
		}
	}),
	simplePanel: css({
		base: {
			boxShadow: '0 0 0 1px {colors.brand.500_12} inset',
			rounded: '6px',
			bgColor: 'white.3',
			pb: '6px',
		}
	}),
	description: css({
		base: {
			color: 'black.3',
			fontSize: '12px',
			lineHeight: '15px',
			fontWeight: '500',
			p: '9px',
			rounded: '6px',
			bgColor: 'var(--other-lv4)',
			mt: '12px',
		}
	}),
	descriptionTitle: css({
		base: {
			color: 'black.2',
			fontSize: '14px',
			lineHeight: '18px',
			fontWeight: '700',
		}
	}),
	arrowIcon: css({
		base: {
			color: 'black.3',
			w: '20px',
			h: '20px',
		}
	}),
	returnIcon: css({
		base: {
			w: '16px',
			h: '16px',
			mr: '3px',
		}
	}),
	jupiterButton: css({
		base: {
			mt: '9px',
			w: '100%',
			fontWeight: 500
		},
		_galaxy: {
			bgColor: 'var(--background-neutral-500-700)',
			color: 'var(--text-neutral-950-050)',
			_supportHover: {
				_hover: {
					bgColor: 'var(--background-neutral-500-700)',
					color: 'var(--text-neutral-950-050)',
				},
			},
		},
		_mars: {
			bgColor: 'transparent',
			color: 'brand.500_light',
		},
	}),
}